// Chart layout keys
export const DEFAULT_LAYOUT_KEY = 'default'
export const AUTOMOTIVE_LAYOUT_KEY = 'automotive'

export const MOBILE_TYPE_LAYOUT_KEY = 'mobile'
export const DEFAULT_TYPE_LAYOUT_KEY = 'default'

// Feedback Adjustments
export const ADJUSTMENT_FILE_SIZE_LIMIT_MB = 5
export const ADJUSTMENT_ACCEPT_TYPES =
  'application/pdf, image/heic, image/png, image/jpeg, text/plain'
